import { VehiclePreview } from '../components';
import { Vehicle } from '@sharedTypes/Vehicle';

interface AddPaymentViewProps {
  nextView: () => void;
  vehicle: Vehicle;
}

const AddPaymentView = ({
  nextView,
  vehicle,
}: AddPaymentViewProps): JSX.Element => {
  return (
    <div className="db-modal__content ac-animation--fade-in-from-right">
      <div className="ch-mt--4 ch-mb--8">
        <h1>Thank you for choosing to reserve this car</h1>
        <p>
          We just need you to confirm a few details to complete your
          reservation.
        </p>
      </div>
      <div className="ch-mt--n4">
        <VehiclePreview {...vehicle} />
      </div>
      <div className="ch-mt--4 ch-mb--2 ch-display--flex">
        <p>Reservation deposit</p>
        <span className="ch-ml--auto ch-text--bold">£99</span>
      </div>

      <div className="ch-text--center">
        <button
          className="ch-btn ch-btn--cta ch-width--12 sm:ch-width--8"
          onClick={nextView}
          type="button"
        >
          Reserve now
        </button>
      </div>
    </div>
  );
};

export default AddPaymentView;
